import {
  cachingInterceptor,
  responseWrappingInterceptor
} from '@gruposaltaedu/liv-http-connect';

import { contentTypeInterceptor } from './content-type.interceptor';
import { langInterceptor } from './lang.interceptor';
import { responseProtocolInterceptor } from './response-protocol.interceptor';
import { timeoutInterceptor } from './timeout.interceptor';

export const httpInterceptorProviders = () => [
  contentTypeInterceptor,
  langInterceptor,
  timeoutInterceptor,
  responseProtocolInterceptor,
  cachingInterceptor,
  responseWrappingInterceptor
];
